// https://docs.methodfi.com/api/elements/auth/intro/#simulate-requirements
export const METHOD_TESTING_PHONES = ['+15121231111', '+15121231112', '+15121231113'];
